<ion-navbar [ngClass]="themeClass">
  <ion-grid>
    <ion-row>
      <ion-col size="4">
        <div class="search-icon" (click)="goBack()">
          <ion-icon name="back-button" class="back-button"></ion-icon>
        </div>
      </ion-col>
      <ion-col size="2" class="header-logo"></ion-col>
      <ion-col size="6" class="ion-justify-content-end" style="text-align: right; display: flex"
        *ngIf="themeClass !== 'mwjp' && themeClass !== 'mwde' && themeClass !== 'mljp' && themeClass !== 'mlde'">
        <app-partager-button [ngClass] = "{'one': include?.length === 1, 'two': include?.length === 2, 'four': include?.length === 4}" [include] = "include" [title]="title" [url]="slug" *ngIf="type !== 'dossier'">
          <ion-icon class="share"></ion-icon>
        </app-partager-button>
        <app-favorite-button [favorited]="favorited || false" [type]= "type" [id]="id" *ngIf="type !== 'dossier' && themeClass !== 'clfy'">
          <span class="add">
            <ion-icon class="favoris-ajouter-plus"></ion-icon>
          </span>
          <span class="remove">
            <ion-icon class="favoris-suprimer-moins"></ion-icon>
          </span>
          <span class="noauth">
            <ion-icon class="favoris-ajouter-plus"></ion-icon>
          </span>
        </app-favorite-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-navbar>
<ion-item [ngClass] = "themeClass" *ngIf="unlogged && themeClass !== 'clfy'" (click)="goToBoutique()" class="bg-header-copy-2" lines="none">
  <ion-label>
    <span class="sabonner-aux-journaux">{{'HEADER.S_ABONNER_AUX_JOURNAUX' | translate}}
      <img class="banner-action-arrow" alt="arrow" src="/../assets/img/icon-arrow-abo-copy.png" class="Icon-Arrow-Abo-copy">
    </span>
  </ion-label>
</ion-item>
